import {
  PENDING_POST_DEVICE_VERIFICATION_ACTION,
  SUCCESS_POST_DEVICE_VERIFICATION_ACTION,
  FAILURE_POST_DEVICE_VERIFICATION_ACTION,
  RESET_DEVICE_VERIFICATION_STATE_ACTION
} from '../actionsTypes';
import F from '../../commons/HTTPFetcher';
import { v4 as uuidv4 } from 'uuid';

export const deviceVerification = ({ url }) => async (dispatch) => {
  dispatch(pendingDeviceVerification());

  try {
    await F.postCors({ url, customHeaders: { 'X-Correlation-Id': uuidv4() } });
    dispatch(setDeviceVerification());
  } catch (errors) {
    dispatch(errorDeviceVerification());
  }
};

const pendingDeviceVerification = () => ({
  type: PENDING_POST_DEVICE_VERIFICATION_ACTION
});

const setDeviceVerification = () => ({
  type: SUCCESS_POST_DEVICE_VERIFICATION_ACTION
});

const errorDeviceVerification = () => ({
  type: FAILURE_POST_DEVICE_VERIFICATION_ACTION
});

export const resetDeviceVerification = () => ({
  type: RESET_DEVICE_VERIFICATION_STATE_ACTION
});
